export const WaterMenu = [
    {
        Id: 1,
        MenuName: "ชาไทย",
        Price: 35,
        WaterPicture: "https://cdn.shopify.com/s/files/1/0022/1393/7252/articles/20230310181037-thai-tea-recipe_1200x1200.webp?v=1678471844",
        Descript: "เอาชาไปต้มแล้วคั้นออกมา จากนั้นเอาไปผสมกับนมแล้วคนด้วยช้อน"
    },
    {
        Id: 2,
        MenuName: "ชาเขียว",
        Price: 35,
        WaterPicture: "https://img.wongnai.com/p/1920x0/2019/02/02/1e0e327a52ce405196bb7242d22ea752.jpg",
        Descript: "ทำเหมือนชาไทยแค่เป็นสีเขียว"
    },
    {
        Id: 3,
        MenuName: "โกโก้",
        Price: 30,
        WaterPicture: "https://www.sccfm.com.my/wp-content/uploads/prod-instant-choc-drink-01.jpg",
        Descript: "เอาผงโกโก้ไปต้มน้ำร้อนแล้วคนด้วยช้อน บางทีคนไม่แตกยังเหลือเป็นผง"
    },
    {
        Id: 4,
        MenuName: "สตรอว์เบอร์รีโซดา",
        Price: 30,
        WaterPicture: "https://www.berlyskitchen.com/wp-content/uploads/2022/02/Strawberry-Soda-Featured-Image.jpg",
        Descript: "โซดาสิงห์ผสมน้ำหวาน กินแล้วชื่นใจ"
    },
    {
        Id: 5,
        MenuName: "แอปเปิ้ลโซดา",
        Price: 30,
        WaterPicture: "https://cf.ltkcdn.net/cocktails/images/orig/305663-1600x1066-green-apple-cocktail.jpg",
        Descript: "ทำเหมือนสตรอว์เบอร์รี่แต่เป็นแอปเปิ้ล"
    },
    {
        Id: 6,
        MenuName: "กีวี่โซดา",
        Price: 30,
        WaterPicture: "https://www.lucismorsels.com/wp-content/uploads/2020/02/Kiwi-Spritzer-2.jpg",
        Descript: "สีเขียวเหมือนกันแต่อร่อยอยู่"
    },
]